__turbopack_context__.v({
  "breathe": "walkthrough-spotlight-module__24CRra__breathe",
  "label": "walkthrough-spotlight-module__24CRra__label",
  "layer": "walkthrough-spotlight-module__24CRra__layer",
  "overlay": "walkthrough-spotlight-module__24CRra__overlay",
  "ring": "walkthrough-spotlight-module__24CRra__ring",
});
